import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// @material-ui/icons
// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";

import styles from "assets/jss/material-kit-react/views/landingPageSections/adsStyle.js";



const useStyles = makeStyles(styles);

export default function Ads2() {
  const classes = useStyles();
  return (
    <div className={classes.section}>
      <GridContainer justify="center" >
        <GridItem xs={12} sm={12} md={12}>
          <div className={classes.container}>
            <div className={classes.title}>
              <h4>حامیان هشتمین دوره مسابقات چالش‌های فناوری اطلاعات کشور</h4>
              <br />
            </div>
          </div>
        </GridItem>
      </GridContainer>
      <div>
        <GridContainer justify="center" >
          <GridItem xs={6} sm={8} md={10}>
            <GridContainer justify="center" >
              <GridItem xs={12} sm={4} md={3}>
                <a className={classes.ATag} target='_blank' href='https://www.amnpardaz.com/index.php/fa/'>
                  <img
                    src={"http://sharifcamp.ir/assets/images/amnpardaz1.jpg"}
                    alt="..."
                    className={classes.imgRounded + " " + classes.imgFluid}
                  />
                  <h5>شرکت نرم افزاری امن پرداز</h5>
                </a>
              </GridItem>
              <GridItem xs={12} sm={4} md={3}>
                <a className={classes.ATag} target='_blank' href='https://takmakaron.com/fa/'>
                  <img
                    src={"http://sharifcamp.ir/assets/images/tak1.jpg"}
                    alt="..."
                    className={classes.imgRounded + " " + classes.imgFluid}
                  />
                  <h5>تک ماکارون</h5>
                </a>
              </GridItem>
              <GridItem xs={12} sm={4} md={3}>
                <a className={classes.ATag} target='_blank' href='https://www.isaco.ir/'>
                  <img
                    src={"http://sharifcamp.ir/assets/images/isaco1.jpg"}
                    alt="..."
                    className={classes.imgRounded + " " + classes.imgFluid}
                  />
                  <h5>ایساکو</h5>
                </a>
              </GridItem>
            </GridContainer>
            <br /><br />
            <GridContainer justify="center" >
              <GridItem xs={12} sm={4} md={3}>
                <a className={classes.ATag} target='_blank' href='https://www.xaas.ir/'>
                  <img
                    src={"http://sharifcamp.ir/assets/images/xaas.jpg"}
                    alt="..."
                    className={classes.imgRounded + " " + classes.imgFluid}
                  />
                  <h5>ابر زس</h5>
                </a>
              </GridItem>
              <GridItem xs={12} sm={4} md={3}>
                <a className={classes.ATag} target='_blank' href='https://www.mapnaec.com/'>
                  <img
                    src={"http://sharifcamp.ir/assets/images/meco1.jpg"}
                    alt="..."
                    className={classes.imgRounded + " " + classes.imgFluid}
                  />
                  <h5>شرکت مهندسی و ساخت برق و کنترل مپنا (مکو)</h5>
                </a>
              </GridItem>
              <GridItem xs={12} sm={4} md={3}>
                <a className={classes.ATag} target='_blank' href='https://www.kanoon.ir/'>
                  <img
                    src={"http://sharifcamp.ir/assets/images/kanon1.jpg"}
                    alt="..."
                    className={classes.imgRounded + " " + classes.imgFluid}
                  />
                  <h5>قلم چی: کانون فرهنگی آموزش</h5>
                </a>
              </GridItem>
              <GridItem xs={12} sm={4} md={3}>
                <a className={classes.ATag} target='_blank' href='https://www.jpcomplex.ir/'>
                  <img
                    src={"http://sharifcamp.ir/assets/images/jam1.jpg"}
                    alt="..."
                    className={classes.imgRounded + " " + classes.imgFluid}
                  />
                  <h5>پتروشیمی جم</h5>
                </a>
              </GridItem>
            </GridContainer>
          </GridItem>
        </GridContainer>
      </div>
    </div>
  );
}
